import React from "react";
import {ButtonStatus, ButtonType} from "./enum";

interface IProps {
    type?: ButtonType,
    status?: ButtonStatus,
    onClick: () => void,
    children: any,
}

export default function Button(props: IProps) {
    const {type = ButtonType.basic, status = ButtonStatus.primary, onClick, children} = props

    const getBasicButtonClass = (): string => {
        let classNameForBasic = ""
        switch (status) {
        case ButtonStatus.primary:
            classNameForBasic = "cursor-pointer inline-block flex-none rounded px-4 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out text-white bg-primary hover:bg-primary-focus"
            break
        case ButtonStatus.secondary:
            classNameForBasic = "cursor-pointer inline-block flex-none rounded px-4 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out bg-secondary border-secondary";
            break
        case ButtonStatus.plain:
            classNameForBasic = "cursor-pointer inline-block flex-none rounded px-4 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out text-gray-3 bg-transparent hover:text-primary hover:bg-primary-light"
            break
        case ButtonStatus.light:
            classNameForBasic = "cursor-pointer cursor-pointer inline-block flex-none rounded px-4 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out bg-gray-5 text-gray-3 hover:bg-gray-5"
            break
        case ButtonStatus.link:
            classNameForBasic = "cursor-pointer leading-none flex flex-row items-center py-0 text-primary text-primary text-sm font-medium border-b border-transparent hover:border-primary"
            break
        case ButtonStatus.float:
            classNameForBasic = "cursor-pointer inline-block flex-none rounded-full px-2 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out text-gray-3 hover:bg-gray-5"
            break
        case ButtonStatus.disabled:
            classNameForBasic = "cursor-pointer inline-block disabled flex-none rounded px-4 py-2 font-semibold text-sm leading-tight focus:outline-none focus:ring-0 transition duration-150 ease-in-out text-white bg-gray-400"
            break
        default:
        }
        return classNameForBasic
    }

    const getOutlineButtonClass = (): string => {
        let classNameForOutline = ""
        switch (status) {
        case ButtonStatus.disabled:
            classNameForOutline = "cursor-pointer inline-block disabled flex-none rounded px-4 py-2 text-gray-400 font-semibold text-sm leading-tight bg-white border border-gray-400 focus:outline-none focus:ring-0 transition duration-150 ease-in-out"
            break
        default:
            classNameForOutline = "cursor-pointer inline-block flex-none rounded px-4 py-2 text-primary font-semibold text-sm leading-tight bg-white hover:text-white border border-primary hover:border-primary hover:bg-primary focus:outline-none focus:ring-0 transition duration-150 ease-in-out"
        }
        return classNameForOutline
    }

    const getClassNameByType = () => {
        if (type === ButtonType.block) {
            return "w-full"
        }
        return ""
    }

    const $basicButton = (
        <button disabled={status === ButtonStatus.disabled} onClick={onClick} type={"button"} className={`cursor-pointer  ${getBasicButtonClass()} ${getClassNameByType()}`}>
            {children}
        </button>
    )

    const $outlineButton = (
        <button disabled={status === ButtonStatus.disabled} onClick={onClick} type={"button"} className={`${getOutlineButtonClass()} ${getClassNameByType()}`} >
            {children}
        </button>
    )

    let $button = $basicButton
    switch (type) {
    case ButtonType.outline:
        $button = $outlineButton
        break
    default:

    }

    return $button
}
